// src/services/departmentService.jsx
import axiosInstance from './axiosConfig';

const departmentService = {
  getAll: async (page = 1, limit = 10) => {
    console.log('API CALL → page:', page, 'limit:', limit);
    const response = await axiosInstance.get(
      `/departments?page=${page}&limit=${limit}`
    );
    return response.data.data ?? response.data;
  },

  getById: async (id) => {
    const response = await axiosInstance.get(`/departments/${id}`);
    return response.data;
  },

  create: async (payload) => {
    const response = await axiosInstance.post('/departments/add', payload);
    return response.data;
  },

  update: async (id, data) => {
    const response = await axiosInstance.put(`/departments/edit/${id}`, data);
    return response.data;
  },

  delete: async (id) => {
    const response = await axiosInstance.delete(`/departments/delete/${id}`);
    return response.data;
  },

  filter: async (filters = {}) => {
    const params = new URLSearchParams();

    if (filters.type) params.append('type', filters.type);
    if (filters.search) params.append('search', filters.search);

    const response = await axiosInstance.get(
      params.toString()
        ? `/departments?${params.toString()}`
        : '/departments'
    );

    return response.data;
  },
};

export default departmentService;
